/**
 * Logger de preview de Emergent (B6, bloque 1 seguridad) — SOLO en preview/local.
 * El script reenvía consola y errores de red (con cuerpos de respuesta) al iframe padre vía
 * postMessage("*"); en producción no debe existir. Antes iba fijo en public/index.html.
 */
const PREVIEW_HOSTS = ['localhost', '127.0.0.1'];
const PREVIEW_SUFFIX = '.preview.emergentagent.com';

export const isPreviewHost = (hostname = window.location.hostname) =>
  PREVIEW_HOSTS.includes(hostname) || hostname.endsWith(PREVIEW_SUFFIX);

export const loadPreviewLogger = () => {
  if (!isPreviewHost()) return false;
  const s = document.createElement('script');
  s.src = 'https://assets.emergent.sh/scripts/emergent-main.js';
  s.crossOrigin = 'anonymous';
  s.async = true;
  document.head.appendChild(s);
  return true;
};
